import React from 'react'
import { SvgIcon, SvgIconType } from '../svg-icon'

// ─── In-app panel chrome ───────────────────────────────────────────────

export function PanelShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col w-full h-full overflow-hidden rounded border border-transparent p-[1px] shadow bg-white focus:!border-wistor text-xs font-inter">
      {children}
    </div>
  )
}

export function PanelHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="drag-handle flex items-center gap-1.5 select-none whitespace-nowrap overflow-hidden text-white rounded-tl rounded-tr bg-wistor cursor-move">
      {children}
    </div>
  )
}

export function PanelHeaderTitle({ icon, title }: { icon?: SvgIconType; title: string }) {
  return (
    <div className="flex-grow flex items-center font-exo font-medium p-1.5 pl-2 gap-1.5">
      {icon && <SvgIcon icon={icon} size={14} />}
      <span className="inline-flex pb-[1px] text-sm font-semibold">{title}</span>
    </div>
  )
}

export function PanelHeaderActions({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-shrink gap-0.5 p-1.5 items-center">
      {children}
    </div>
  )
}

export function PanelBody({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col flex-grow min-h-0 h-full w-full bg-neutral-100 overflow-auto rounded-bl rounded-br">
      {children}
    </div>
  )
}

// ─── StandalonePage panel chrome ───────────────────────────────────────────────

export function StandalonePageShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-screen flex flex-col">
      {children}
    </div>
  )
}

export function StandalonePageTopBar({ title, detail }: { title: string; detail?: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-wistor border-b border-wistor flex-shrink-0">
      <h1 className="text-white text-sm font-exo font-semibold">{title}</h1>
      {detail && (
        <span className="text-white/60 text-xs font-mono truncate max-w-[60%]">
          {detail}
        </span>
      )}
    </div>
  )
}

export function StandalonePageBody({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0 }}>
      {children}
    </div>
  )
}

export function StandalonePageMessage({ children, variant = 'neutral' }: {
  children: React.ReactNode
  variant?: 'neutral' | 'error'
}) {
  return (
    <div className={`flex-1 flex items-center justify-center ${variant === 'error' ? 'text-red-500' : 'text-neutral-500'}`}>
      {children}
    </div>
  )
}
